import { type AnyBackendMessageBody } from '../../types';

export const flattenMessageForFrontend = ({
	context,
	...message
}: AnyBackendMessageBody): Omit<AnyBackendMessageBody, 'context'> => ({ ...message, ...context });

/**
 * By convention we flatten the response on the backend so we aren't so reliant on memoizing props on the frontend.
 */
export const flattenMessagesForFrontend = (
	messages: Array<AnyBackendMessageBody>,
): Array<Omit<AnyBackendMessageBody, 'context'>> => messages.map(flattenMessageForFrontend);
